import rootActions from "../rootActions";

class chestActions extends rootActions {
  constructor(params) {
    super(params);
  }
}

export default chestActions;
